import { useEffect, useRef } from 'react';
import { useUi } from '@weareconceptstudio/core';

//* Styles
import BurgerMenuIconStyle from './style';

const BurgerMenuIcon = () => {
	const wrapperInnerRef = useRef();
	const { winWidth, isBurgerMenuOpen, toggleBurgerMenu } = useUi();

	function menuBtnFunction() {
		toggleBurgerMenu();
		if (wrapperInnerRef.current) {
			wrapperInnerRef.current.classList.toggle('active');
		}
	}

	useEffect(() => {
		if (!isBurgerMenuOpen && wrapperInnerRef.current) {
			wrapperInnerRef.current.classList.remove('active');
		}
	}, [winWidth, isBurgerMenuOpen]);

	return (
		<BurgerMenuIconStyle onClick={menuBtnFunction}>
			<div
				ref={wrapperInnerRef}
				className='menu-btn-1'
			>
				<span />
			</div>
		</BurgerMenuIconStyle>
	);
};

export default BurgerMenuIcon;
